import { dashboardMaxDate } from './dashboardDateRange';
import { DateRangePicker } from '@shigo-ui/ui';

import { dashboardT } from '@/lib/messages';
import { dashboardPresets } from './dashboardPresets';
import { DashboardDatePreset, type DashboardDateRange } from './model';

interface DashboardDateControlProps {
  value: DashboardDateRange;
  onChange: (value: DashboardDateRange) => void;
  showDayNavigation: boolean;
}

export function DashboardDateControl({
  value,
  onChange,
  showDayNavigation,
}: DashboardDateControlProps) {
  return (
    <div title={dashboardT('dashboard.date.utcHint')}>
      <DateRangePicker
        showDayNavigation={showDayNavigation}
        label={dashboardT('dashboard.date.label')}
        previousDayLabel={dashboardT('dashboard.date.previous')}
        nextDayLabel={dashboardT('dashboard.date.next')}
        value={value}
        presets={dashboardPresets()}
        maxDate={dashboardMaxDate()}
        onChange={(next) => {
          const preset = Object.values(DashboardDatePreset).find(
            (candidate) => candidate === next.preset,
          );
          onChange({
            dateFrom: next.dateFrom,
            dateTo: next.dateTo,
            ...(preset ? { preset } : {}),
          });
        }}
        triggerClassName="min-w-[240px]"
      />
    </div>
  );
}
